module.exports = __webpack_public_path__ + "img/icon-view.8d940711.svg";